import {httpService} from '../App'
import {encode as base64_encode} from 'base-64';
import { createLogger } from '../utils/logger';

const logger = createLogger('AuthService');

export interface UserDetails {
    user:string;
    identity:string;
}

export class AuthService {

  public async login(pin: string):Promise<boolean>{
    let idt = base64_encode(pin);
    logger.debug('login()')
    
    try {
      const response = await httpService.getClient().post(`api/auth/login`, {
        identity: idt
      });

      //console.log(response);
      const result = response?.status === 200;
      return result
    } catch (error) {
      //console.error(error);
      return false;
    }
  }

  public async refreshLogin():Promise<boolean>{
    //console.log(`${TAG} refreshLogin()`);

    try {
      const response = await httpService.getClient().post(`api/auth/refresh_token`, 
      {}
      );

      //console.log(`${TAG} ${response}`);
      const result = response?.status === 200;
      return result
     } catch (error) {
       logger.error(error);
       return false;
     }
   }

   public async logout():Promise<boolean>{
     try {
       const response = await httpService.getClient().post(`api/auth/logout`, {});
       logger.debug('logout() - request sent to backend');
       return response?.status === 200;
     } catch (error) {
       logger.error('logout() error:', error);
       return false;
     }
   }

   public async readUser():Promise<UserDetails | undefined>{

     try {
       const response = await httpService.getClient()
       .post(`api/users/details`);

       logger.debug(`readUser response: ${response?.data}`);
       return response?.data
     } catch (error) {
       logger.error(error);
      return undefined;
    }
  }


}
